<template>
    <div class="rank-list-container">
        <div class='rank-list-title'>
            <div>名次</div>
            <div>站点</div>
            <div>报警总数</div>
        </div>
        <ul class="rank-list-infinite">
            <li v-for="(item, index) in rankData" 
                :key="index"
                @mouseover="showPopover($event, index, item)"
                @mouseleave="closePopover()"
                ref="clickOverlay"
                class="rank-list-item"
                :class="{ active: checkedItem===index}">
                <div class="box">{{index + 1}}</div>
                <div class="box">
                    {{item.name}}
                    <div class="popover" v-show="item.isshow" >
                        <Popover :data="popoverData[item.areaId]" :time="time"></Popover>
                    </div>
                </div>
                <div class="box">{{item.num}}</div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Popover from '../../../components/accidentManagement/rank/Popover.vue';
    import {
        AlarmStatistics
    } from '../../../api/accident';
export default {
    props: {
        rankData: Array,
        popoverData:Object,
        time:Number,
    },
    components:{
        Popover
    },
    data () {
        return {
            checkedItem: -1,
            isShowPopover:false,
            bankSwitch:true,
            rankPieData:{},
        }
    },
    watch:{
        rankData(n,o){
            return n.map( (value,index,array)=>{
                value.isshow = false
            })  
        }
    },
    mounted(){
        document.addEventListener('click', this.closePopover)
        // this.getAlarmStatistics();
    },
    methods: {
        // async getAlarmStatistics(){
        //     let result = await AlarmStatistics({
        //         start: this.timeRange[0],
        //         end: this.timeRange[1],
        //         projectId: this.projectId
        //     });
        //     debugger
        //     this.rankPieData = result.data.data.eventNum
        // },
        showPopover: function(evt, index, id) {
            // if (index === this.checkedItem) {
            //     this.closePopover();
            //     return;
            // }
            // let tree = this.$refs.clickOverlay[index].contains(evt.target) // 这最关键的代码,判断是否点击了内部区域
            // if(!tree){
            //   this.rankData.map( (value,index,array)=>{
            //     value.isshow = false
            // })  
            // return
            // }
            this.rankData.map( (value,index,array)=>{
                value.isshow = false
            })  
            id.isshow = true
            this.checkedItem = index;
        },
        closePopover: function() {
            this.checkedItem = -1;
            this.rankData.map( (value,index,array)=>{
                value.isshow = false
            })  
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closePopover);
    }
}
</script>

<style lang="less" scoped>
.popover {
    position: absolute;
    // .w(461);
    // .h(288);
    background: #fff;
    transform: translateY(-65%);
    z-index: 2;

    .el-card {
        height: 100%;
    }
}


.rank-list-container {
    height: 100%;

    .rank-list-title {
        display: flex;
        justify-content: space-around;
        .h(64);
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        
        div {
            min-width: 33.33%;
            .h(64);
            display: flex;
            justify-content: center;
            align-items: center;
            
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }
    }

    .rank-list-infinite{
        overflow: hidden;
        overflow-y: scroll;
        white-space: nowrap;
        .h(311);

        //火狐隐藏滚动条
        scrollbar-width: none;

        .active {
            background: rgba(0, 0, 0, 0.04);
        }

        .rank-list-item {
            display: flex;
            justify-content: space-around;
            border-bottom: 1px solid #E5E5E5;
            cursor: pointer;

            div.box {
                min-width: 33.33%;
                .h(64);
                display: flex;
                justify-content: center;
                align-items: center;

                font-size: 18rem;
                font-weight: 400;
                color: #666666;
            }
        }
    }

    ::-webkit-scrollbar {
        display: none;
    }
}
</style>